import { Observable } from 'rxjs';
import { EndpointsName } from './../../Auth/authTypes';
import { map, skipWhile } from "rxjs/operators";
import { get } from "../../Auth";
import {
    ADCData,
    ARCData,
    AWRCFeedbackData,
    AWRCRareStreamData,
    BALRareStreamData,
    ProcessType,
} from "../../types";

const buildGetALCInitialDataEndpoint = (processor: ProcessType) => `/${processor}/results`;


export const getFirstElementOfArray = <T>(observableObject: Observable<T[]>) =>
    observableObject.pipe(
        skipWhile(data => !data || !data.length),
        map(data => data[0])
    );

const mergeADCdata = <T>(observableObject: Observable<T[]>) =>
    observableObject.pipe(
        skipWhile(data => !data || !data.length),
        map(data => data.length === 1
            ? data[0]
            : Object.assign(data[0], data[1]))
    );

export const getARCInitialData = () => get<ARCData[]>(EndpointsName.BBF, buildGetALCInitialDataEndpoint(ProcessType.ARC));
export const getAWRCInitialData = () => getFirstElementOfArray(get<AWRCRareStreamData[]>(EndpointsName.BBF, buildGetALCInitialDataEndpoint(ProcessType.AWRC)));
export const getADCInitialData = () => mergeADCdata(get<[ADCData, AWRCFeedbackData]>(EndpointsName.BBF, buildGetALCInitialDataEndpoint(ProcessType.ADC)));
export const getCDSInitialData = () => getFirstElementOfArray(get<any>(EndpointsName.BBF, buildGetALCInitialDataEndpoint(ProcessType.CDS)));
export const getBALInitialData = () => get<BALRareStreamData[]>(EndpointsName.BBF, buildGetALCInitialDataEndpoint(ProcessType.BAL));


